import { RoomState } from "backend/src/common/types/roomState";
import { getOrCreateSocket } from "socket/socket";
import { store } from "store/store";

export const removeBot = () => {
  const socket = getOrCreateSocket();
  if (store.currentRoom && store.roomState === RoomState.pending) {
    socket.emit("removeBot", store.currentRoom);
  }
};
